import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatChip, MatChipSet } from '@angular/material/chips';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { AdComponent } from '@x/common/ads/components/ad/ad.component';
import { ObserveVisibilityDirective } from '@x/common/browser/directives/observe-visibility.directive';
import { LoaderModule } from '@x/common/loader';
import { MarkdownModule } from '@x/common/markdown';
import { MoneyModule } from '@x/common/money';
import { MoneyPipe } from '@x/common/money/money.pipe';
import { OperationModule } from '@x/common/operation';
import { SwiperSlideComponent } from '@x/common/swiper/swiper-slide/swiper-slide.component';
import { SwiperComponent } from '@x/common/swiper/swiper.component';
import { TrackingProductClickDirective } from '@x/common/tracking/directives/tracking-product-click.directive';
import { ProductAddToBagComponent } from '@x/ecommerce-shop/app/core/product/components/product-add-to-bag/product-add-to-bag.component';
import { ProductAttributesComponent } from '@x/ecommerce-shop/app/core/product/components/product-attributes/product-attributes.component';
import { ProductBadgeComponent } from '@x/ecommerce-shop/app/core/product/components/product-badges/product-badges.component';
import { ProductCardComponent } from '@x/ecommerce-shop/app/core/product/components/product-card/product-card.component';
import { ProductListItemComponent } from '@x/ecommerce-shop/app/core/product/components/product-list-item/product-list-item.component';
import { ProductOptionsFormComponent } from '@x/ecommerce-shop/app/core/product/components/product-options-form/product-options-form.component';
import { ProductPriceComponent } from '@x/ecommerce-shop/app/core/product/components/product-price/product-price.component';
import { ProductPricePipe } from '@x/ecommerce-shop/app/core/product/components/product-price/product-price.pipe';
import { ProductSwiperSliderComponent } from '@x/ecommerce-shop/app/core/product/components/product-swiper-slider/product-swiper-slider.component';
import { VariantAvailabilityComponent } from '@x/ecommerce-shop/app/core/product/components/variant-availability/variant-availability.component';
import { AvailabilityService } from '@x/ecommerce-shop/app/core/product/services/availability.service';
import { ProductListItemService } from '@x/ecommerce-shop/app/core/product/services/product-list-item.service';
import { SearchQParamsPipe } from '@x/ecommerce-shop/app/core/search/pipes/search-q-params.pipe';
import { ShopErrorModule } from '@x/ecommerce-shop/app/core/shop-error/shop-error.module';
import { AddToCartButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/add-to-cart-button/add-to-cart-button.module';
import { BadgeModule } from '@x/ecommerce-shop/app/core/shop-ui/components/badge';
import { GhostAddToCartModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-add-to-cart/ghost-add-to-cart.module';
import { GhostParagraphModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-paragraph/ghost-paragraph.module';
import { GhostProductMediaModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-product-media/ghost-product-media.module';
import { GhostTitleModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-title/ghost-title.module';
import { ProductMediaModule } from '@x/ecommerce-shop/app/core/shop-ui/components/product-media/product-media.module';
import { SyncHeightToElement } from '@x/ecommerce-shop/app/core/utils/directives/sync-height-to-element.directive';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { WishlistModule } from '@x/ecommerce-shop/app/core/whishlist/wishlist.module';

@NgModule({
  providers: [ProductListItemService, AvailabilityService, MoneyPipe, SearchQParamsPipe],
  declarations: [
    ProductCardComponent,
    ProductListItemComponent,
    ProductSwiperSliderComponent,
    VariantAvailabilityComponent,
    ProductAddToBagComponent,
    ProductAttributesComponent,
    ProductBadgeComponent,
    ProductOptionsFormComponent,
    ProductPriceComponent,
    ProductPricePipe,
  ],
  exports: [
    ProductCardComponent,
    ProductListItemComponent,
    ProductSwiperSliderComponent,
    VariantAvailabilityComponent,
    ProductAddToBagComponent,
    ProductAttributesComponent,
    ProductBadgeComponent,
    ProductOptionsFormComponent,
    ProductPriceComponent,
  ],
  imports: [
    CommonModule,
    RouterLink,
    OperationModule,
    LoaderModule,
    ShopErrorModule,
    WishlistModule,
    MatButtonModule,
    AddToCartButtonModule,
    MoneyModule,
    ProductMediaModule,
    MatChipSet,
    MatChip,
    MatTooltip,
    UtilsModule,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    MarkdownModule,
    BadgeModule,
    MatButtonToggleGroup,
    ReactiveFormsModule,
    MatButtonToggle,
    GhostTitleModule,
    GhostParagraphModule,
    GhostProductMediaModule,
    GhostAddToCartModule,
    SwiperComponent,
    TrackingProductClickDirective,
    SearchQParamsPipe,
    AdComponent,
    SyncHeightToElement,
    ObserveVisibilityDirective,
    SwiperSlideComponent,
  ],
})
export class ProductModule {}
